<app-event-presentation [event]="event" *ngIf="getSessionLength() === 0"></app-event-presentation>

<app-event-single-session [sectionContent]="sectionContent" [event]="event" [eventSession]="event.eventSessions[0]" *ngIf="getSessionLength() === 1"></app-event-single-session>
